import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import Sales from "layouts/sales";
import Settings from "layouts/settings";
import { SettingsSuggest } from "@mui/icons-material";
import Stores from "layouts/stores";
import DashboardAdmin from "layouts/dashboardAdmin"

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/",
    component: <DashboardAdmin />,
  },
  {
    type: "collapse",
    name: "Lojas",
    key: "stores",
    icon: <Icon fontSize="small">storefront_icon</Icon>,
    route: "/stores",
    component: <Stores />,
  }
];

export default routes;